(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@duik/use-open-state"), require("@duik/button"), require("@duik/outer-events-handler"));
	else if(typeof define === 'function' && define.amd)
		define(["@duik/use-open-state", "@duik/button", "@duik/outer-events-handler"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@duik/use-open-state"), require("@duik/button"), require("@duik/outer-events-handler")) : factory(root["@duik/use-open-state"], root["@duik/button"], root["@duik/outer-events-handler"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 79);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"dropdown","dropdown-menu":"dropdown-menu","show":"show","bottom-right":"bottom-right","bottom-left":"bottom-left","bottom-center":"bottom-center","top-right":"top-right","top-left":"top-left","top-center":"top-center","right-center":"right-center","right-top":"right-top","right-bottom":"right-bottom","left-center":"left-center","left-top":"left-top","left-bottom":"left-bottom","dropdown-toggle":"dropdown-toggle","btn-square":"btn-square","dropdown-toggle-no-arrows":"dropdown-toggle-no-arrows","btn":"btn","dropdown-item":"dropdown-item","dropdown-toggle-split":"dropdown-toggle-split"};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__11__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(1);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: external "@duik/outer-events-handler"
var outer_events_handler_ = __webpack_require__(11);

// EXTERNAL MODULE: external "@duik/use-open-state"
var use_open_state_ = __webpack_require__(4);

// EXTERNAL MODULE: ./packages/Dropdown/styles.scss
var styles = __webpack_require__(108);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// CONCATENATED MODULE: ./packages/Dropdown/DropdownMenu.tsx
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DropdownMenu_DropdownMenu = /** @class */ (function (_super) {
    __extends(DropdownMenu, _super);
    function DropdownMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.displayName = 'DropdownMenu';
        _this.ref = external_react_["createRef"]();
        _this.resetRepositionState = function () {
            var menuPosition = _this.props.menuPosition;
            _this.setState({
                menuPosition: menuPosition || DropdownMenuPosition['bottom-left'],
                repositioned: false
            });
        };
        // set default
        _this.state = {
            menuPosition: props.menuPosition || DropdownMenuPosition['bottom-left'],
            repositioned: false
        };
        return _this;
    }
    DropdownMenu.prototype.componentDidMount = function () {
        if (window) {
            window.addEventListener('scroll', this.resetRepositionState, true);
        }
    };
    DropdownMenu.prototype.componentWillUnmount = function () {
        if (window) {
            window.removeEventListener('scroll', this.resetRepositionState, true);
        }
    };
    DropdownMenu.prototype.componentDidUpdate = function () {
        if (!this.props.isOpen || this.state.repositioned) {
            return;
        }
        // perform reposition if necessary
        if (this.ref.current) {
            var rect = this.ref.current.getBoundingClientRect();
            var windowHeight = window.innerHeight;
            var windowWidth = window.innerWidth;
            var bottom = windowHeight > rect.height + rect.top;
            var top_1 = rect.top > 0;
            var left = rect.left > 0;
            var right = rect.right < windowWidth;
            // we don't need to reposition
            if (bottom && top_1 && left && right) {
                return;
            }
            // this is very naive implementation that doesn't take in account the initial position
            var nextMenuPosition = this.state.menuPosition;
            if (!bottom) {
                nextMenuPosition = nextMenuPosition.replace('bottom', 'top');
            }
            else if (!top_1) {
                nextMenuPosition = nextMenuPosition.replace('top', 'bottom');
            }
            if (!left) {
                nextMenuPosition = nextMenuPosition.replace('left', 'right');
                nextMenuPosition = nextMenuPosition.replace('center', 'right');
            }
            else if (!right) {
                nextMenuPosition = nextMenuPosition.replace('right', 'left');
                nextMenuPosition = nextMenuPosition.replace('center', 'left');
            }
            this.setState({
                menuPosition: nextMenuPosition,
                // reposition only once
                repositioned: true
            });
        }
    };
    DropdownMenu.prototype.render = function () {
        var _a;
        var _b = this.props, 
        // remove this from ...rest
        handleClose = _b.handleClose, handleOpen = _b.handleOpen, setOpenState = _b.setOpenState, handleToggle = _b.handleToggle, menuPosition = _b.menuPosition, 
        // using
        className = _b.className, isOpen = _b.isOpen, children = _b.children;
        return (external_react_["createElement"]("div", { ref: this.ref, className: external_classnames_default()(styles_default.a['dropdown-menu'], className, (_a = {},
                _a[styles_default.a['show']] = isOpen,
                _a[styles_default.a[this.state.menuPosition]] = this.state.menuPosition,
                _a)) }, children));
    };
    return DropdownMenu;
}(external_react_["PureComponent"]));

/* harmony default export */ var Dropdown_DropdownMenu = (DropdownMenu_DropdownMenu);

// EXTERNAL MODULE: external "@duik/button"
var button_ = __webpack_require__(8);

// CONCATENATED MODULE: ./packages/Dropdown/DropdownButton.tsx
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var DropdownButton = function (props) {
    var _a;
    var 
    // remove this from ...rest
    handleClose = props.handleClose, handleOpen = props.handleOpen, setOpenState = props.setOpenState, 
    // using
    handleToggle = props.handleToggle, isOpen = props.isOpen, children = props.children, className = props.className, _b = props.hideArrows, hideArrows = _b === void 0 ? false : _b, rest = __rest(props, ["handleClose", "handleOpen", "setOpenState", "handleToggle", "isOpen", "children", "className", "hideArrows"]);
    return (external_react_["createElement"](button_["Button"], __assign({ className: external_classnames_default()(styles_default.a['dropdown-toggle'], className, (_a = {},
            _a[styles_default.a['dropdown-toggle-no-arrows']] = hideArrows,
            _a)), onClick: handleOpen, "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": isOpen ? 'true' : 'false' }, rest), children));
};
DropdownButton.defaultProps = {
    children: 'Action'
};
DropdownButton.displayName = 'DropdownButton';
/* harmony default export */ var Dropdown_DropdownButton = (DropdownButton);

// CONCATENATED MODULE: ./packages/Dropdown/DropdownItem.tsx
var DropdownItem_assign = (undefined && undefined.__assign) || function () {
    DropdownItem_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DropdownItem_assign.apply(this, arguments);
};
var DropdownItem_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var DropdownItem = function (props) {
    var className = props.className, rest = DropdownItem_rest(props, ["className"]);
    return (external_react_["createElement"](button_["Button"], DropdownItem_assign({ className: external_classnames_default()(styles_default.a["dropdown-item"], className) }, rest)));
};
DropdownItem.displayName = "DropdownItem";

// CONCATENATED MODULE: ./packages/Dropdown/index.tsx
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenuPosition", function() { return DropdownMenuPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return Dropdown; });
/* concated harmony reexport DropdownButton */__webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return DropdownButton; });
/* concated harmony reexport DropdownItem */__webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return DropdownItem; });
/* concated harmony reexport DropdownMenu */__webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return DropdownMenu_DropdownMenu; });
var Dropdown_assign = (undefined && undefined.__assign) || function () {
    Dropdown_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Dropdown_assign.apply(this, arguments);
};
var Dropdown_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};










var DropdownMenuPosition;
(function (DropdownMenuPosition) {
    DropdownMenuPosition["left-top"] = "left-top";
    DropdownMenuPosition["left-center"] = "left-center";
    DropdownMenuPosition["left-bottom"] = "left-bottom";
    DropdownMenuPosition["right-top"] = "right-top";
    DropdownMenuPosition["right-center"] = "right-center";
    DropdownMenuPosition["right-bottom"] = "right-bottom";
    DropdownMenuPosition["top-left"] = "top-left";
    DropdownMenuPosition["top-right"] = "top-right";
    DropdownMenuPosition["top-center"] = "top-center";
    DropdownMenuPosition["bottom-left"] = "bottom-left";
    DropdownMenuPosition["bottom-right"] = "bottom-right";
    DropdownMenuPosition["bottom-center"] = "bottom-center";
})(DropdownMenuPosition || (DropdownMenuPosition = {}));
var Dropdown = function (props) {
    var _a = props.ButtonComponent, ButtonComponent = _a === void 0 ? Dropdown_DropdownButton : _a, _b = props.buttonProps, buttonProps = _b === void 0 ? {} : _b, _c = props.MenuComponent, MenuComponent = _c === void 0 ? Dropdown_DropdownMenu : _c, _d = props.menuProps, menuProps = _d === void 0 ? {} : _d, childrenProp = props.children, _e = props.menuPosition, menuPosition = _e === void 0 ? DropdownMenuPosition['bottom-right'] : _e, buttonText = props.buttonText, className = props.className, externalOpenControls = props.openControls, block = props.block, _f = props.closeOnOptionClick, closeOnOptionClick = _f === void 0 ? false : _f, rest = Dropdown_rest(props, ["ButtonComponent", "buttonProps", "MenuComponent", "menuProps", "children", "menuPosition", "buttonText", "className", "openControls", "block", "closeOnOptionClick"]);
    var openControls = externalOpenControls || Object(use_open_state_["useOpenState"])(false);
    var children = (typeof childrenProp === 'function' && childrenProp(openControls)) ||
        (closeOnOptionClick &&
            external_react_["Children"].map(childrenProp, function (el) {
                // adds onClick: handleClose
                if (el) {
                    try {
                        return external_react_["cloneElement"](el, {
                            onClick: function (e) {
                                openControls.handleClose();
                                if (el.props.onClick) {
                                    el.props.onClick(e);
                                }
                            }
                        });
                    }
                    catch (e) {
                        return el;
                    }
                }
                return el;
            })) ||
        childrenProp;
    return (external_react_["createElement"](outer_events_handler_["OuterEventsHandler"], Dropdown_assign({ className: external_classnames_default()(styles_default.a['dropdown'], 'btn-group', className), onOuterEvent: openControls.isOpen ? openControls.handleToggle : null }, rest),
        external_react_["createElement"](ButtonComponent, Dropdown_assign({}, openControls, buttonProps, { block: block }), buttonText),
        external_react_["createElement"](MenuComponent, Dropdown_assign({}, menuProps, openControls, { menuPosition: menuPosition }), typeof children === 'function' ? children(openControls) : children)));
};
Dropdown.displayName = 'Dropdown';
/* harmony default export */ var packages_Dropdown = __webpack_exports__["default"] = (Dropdown);


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});